import React from 'react';
import PropTypes from 'prop-types';
import {settingsUiTexts} from 'data/ui-texts';
import {getText} from 'helpers/language-helper';
import Background from 'components/background/background';
import './loading.scss';

const Loading = ({languageId, loadErrMsg, handleLogout}) => {

	const loadingText = (loadErrMsg ? loadErrMsg : getText(settingsUiTexts.loadingGame, languageId));

	return (
		<div className="Loading">
			<Background />
			<div className="Loading-panel" >
				<div className="Loading-logoutBtn" onClick={() => {handleLogout();}} />
				<div className="Loading-content">
					<div className="Loading-circles">
						<div className="Loading-circle" />
						<div className="Loading-circle" />
						<div className="Loading-circle" />
					</div>
					<div className="Loading-text">{loadingText}</div>
				</div>
			</div>
		</div>
	);
};

Loading.propTypes = {
	languageId: PropTypes.string.isRequired,
	loadErrMsg: PropTypes.string,
	handleLogout: PropTypes.func.isRequired,
};

export default Loading;
